
import { AccountModel } from "../models/account-model";

export class RecentDetailsResponse {
    fboUsers: AccountModel[];
    retailUsers: AccountModel[];
    preferredUsers: AccountModel[];
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/recent-details-response.ts